import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../views/Main.vue';
import Login from '../views/Login.vue';
import { store } from '../store';
import Api from '../lib/Api';
import EventBus from '@/lib/EventBus';


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'main',
        component: Main
    },
    {
        path: '/login/',
        name: 'login',
        component: Login
    },
    {
        path: '/projects/',
        name: 'project-list',
        component: () => import('../views/ProjectList.vue')
    },
    {
        path: '/projects/add/',
        name: 'project-add',
        component: () => import('../views/ProjectEdit.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/',
        name: 'project-main',
        component: () => import('../views/ProjectMain.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/edit/',
        name: 'project-edit',
        component: () => import('../views/ProjectEdit.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/phones/',
        name: 'phone-list',
        component: () => import('../views/PhoneList.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/phones/add/',
        name: 'phone-add',
        component: () => import('../views/PhoneEdit.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/phones/:phoneId',
        name: 'phone-edit',
        component: () => import('../views/PhoneEdit.vue'),
        props: true
    },
    {
        path: '/projects/:projectId/statistics',
        name: 'statistics-main',
        component: () => import('../views/StatisticsMain.vue'),
        props: true,
        children: [{
            path: '',
            name: 'statistics-overview',
            component: () => import('../views/StatisticsOverview.vue'),
            props: true
        }, {
            path: 'incoming',
            name: 'statistics-incoming',
            component: () => import('../views/StatisticsIncoming.vue'),
            props: true
        }, {
            path: 'outgoing',
            name: 'statistics-outgoing',
            component: () => import('../views/StatisticsOutgoing.vue'),
            props: true
        }]
    },
    {
        path: '/projects/:projectId/calls/',
        name: 'call-list',
        component: () => import('../views/CallList.vue'),
        props: true
    }

];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

const loadUser = () => {
    if (!store.state.user && store.isAuthenticated() &&
        store.state.auth.user_id) {
        console.log('loading current user');
        return Api.getUser(store.state.auth.user_id).then(user => {
            console.log('loaded');
            store.setUser(user);
            return true;
        });
    }
    return Promise.resolve(true);
};

const loadInitialData = () => {
    if (!store.state.projects.length && store.isAuthenticated()) {
        console.log('loading projects');
        return Api.getProjects().then(projects => {
            store.setProjects(projects);
            return true;
        });
    }
    return Promise.resolve(true);
};

const refreshToken = () => {
    if (store.needsRefresh()) {
        console.log('refreshing token');
        return Api.doRefresh();
    }
    return Promise.resolve(true);
};

// Install refresh timer
setInterval(() => {
    refreshToken();
}, 60);

router.beforeEach((to, from, next) => {

    if (to.name !== 'login' && !store.isAuthenticated()) {
        next({ name: 'login' });
    } else {
        // Load everything
        refreshToken().then(() => {
            return Promise.all([loadInitialData(), loadUser()]).then(() => {
                if (to.params.projectId) {
                    store.setCurrentProject(parseInt(to.params.projectId));
                } else {
                    store.setCurrentProject(null);
                }

                // Redirect into first project on login if there is one
                if (from.name === 'login' &&
                    to.name === 'main' &&
                    store.isAuthenticated() &&
                    store.state.projects.length === 1) {

                    next({name: 'project-main',
                          params: {projectId: store.state.projects[0].id}});

                } else {
                    // Just open next url
                    next();
                }
            }).catch((error) => {
                EventBus.$emit('error', error);
            });
        }).catch(() => {
            next({ name: 'login' });
        });
    }

});

export default router;
